module.exports = __webpack_public_path__ + "img/video-player/pause_overlay-f44a2b469334340aa95f4792e1377a14.svg";